<div *ngIf="isLoggedIn; else loggedOut">
  <div class="tab-game-history">
    <div class="tab-game-history__column">
      <fz-history-list-table
        [loggedIn]="isLoggedIn"
        (pageChange)="onGameHistoryPageChange($event)"
        [gameHistory]="gameHistory"
        [totalGameHistory]="totalGameHistory"
        [tryFreeEnabled]="false"
        [loading]="!loaded"
        [page]="page"
        (login)="onLogin()"
        [level]="'event'"
      >
      </fz-history-list-table>
      <div class="bottom-spacer"></div>
      <ng-container *ngTemplateOutlet="playControls"></ng-container>
    </div>
    <div class="tab-game-history__column summary">
      <fz-score-summary
        [showSummary]="user?.user !== null && user?.user !== undefined"
        [eventCode]="eventCode"
        [prizeImage]="prizeImage"
        [isLEP]="isLEP"
        [seats]="eventScheduleDetails?.totalEntryCount"
        [bestScore]="bestScores"
        [prizeValue]="eventScheduleDetails?.firstPrize?.prizeValue"
        [entryAmount]="eventScheduleDetails?.entryAmount"
        [eventScheduleDetails]="eventScheduleDetails"
        [metadata]="details?.metadata"
      ></fz-score-summary>
    </div>
  </div>
</div>

<ng-template #loggedOut>
  <div class="container inner-spacing">
    <fz-empty-list
      [isLoggedIn]="false"
      (loginEvent)="onLogin()"
    ></fz-empty-list>
  </div>
</ng-template>
